import { Instance, WidgetAnnotation } from '@nutrient-sdk/viewer'
import {
  CustomPdfScript,
  EditablePdfButtonGroup,
} from '@urbanx/agx-ui-components'
import { SellersDisclosureFieldsScript } from './SellersDisclosureScripts'

export interface CustomPdfScriptProps {
  instance: Instance
  buttonGroups?: EditablePdfButtonGroup[]
  onFieldAdded?: (widget: WidgetAnnotation) => void
}

const customPdfScripts: Record<
  CustomPdfScript,
  (props: CustomPdfScriptProps) => Promise<void>
> = {
  [CustomPdfScript.None]: async () => {},
  [CustomPdfScript.SellersDisclosureFields]: SellersDisclosureFieldsScript,
}

export default customPdfScripts
